<div class="flex items-center justify-between">
  <div class="z-20 relative">
    <p-button
      label="{{'animalMedia.multiSelection' | transloco}}"
      icon="pi pi-check-square"
      styleClass="p-button-outlined"
      (click)="onToggleMultiSelectMode()"
      [disabled]="media.length <= 1 || isMultiSelectMode"
    />
  </div>
  <app-media-upload
    [animal]="animal"
    class="right-0"
  />
</div>
<p-fieldset legend="Filter" class="flex-1 relative z-20">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row gap-2">
      <p-toggleswitch [(ngModel)]="filter.showImages" (ngModelChange)="filterChange.emit()"/>
      <span class="uppercase text-sm font-semibold text-gray-500">
      {{ 'animalMedia.filter.images' | transloco }}
    </span>

      <p-toggleswitch [(ngModel)]="filter.showVideos" (ngModelChange)="filterChange.emit()"/>
      <span class="uppercase text-sm font-semibold text-gray-500">
      {{ 'animalMedia.filter.videos' | transloco }}
    </span>
    </div>
    <div class="flex flex-col gap-3">
    <span class="uppercase text-sm font-semibold text-gray-500">
      {{ 'animalMedia.filter.sync.headline' | transloco }}
    </span>
      <div class="flex flex-wrap gap-4">
        <div class="flex gap-2">
          <p-checkbox
            [(ngModel)]="filter.syncWithWebsite"
            inputId="syncWebsite"
            binary="true"
            (ngModelChange)="filterChange.emit()"
          />
          <label for="syncWebsite" class="text-sm">
            {{ 'animalMedia.filter.sync.website' | transloco }}
          </label>
        </div>
        <div class="flex gap-2">
          <p-checkbox
            [(ngModel)]="filter.sharePointImport"
            inputId="sharePoint"
            binary="true"
            (ngModelChange)="filterChange.emit()"
          />
          <label for="sharePoint" class="text-sm">
            {{ 'animalMedia.filter.sync.sharepoint' | transloco }}
          </label>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-2">
        <span
          class="uppercase text-sm font-semibold text-gray-500">{{ 'animalMedia.labels.category' | transloco }}</span>
      <div class="flex flex-wrap gap-2">
        @for (cat of mediaCategoryOptions; track cat.value) {
          <p-chip
            class="cursor-pointer"
            [label]="('animal.imageCategory.' + cat.value) | transloco"
            [removable]="false"
            [ngClass]="{
            'bg-primary text-white': isSelectedCategory(cat.value),
            'bg-gray-200 text-gray-800': !isSelectedCategory(cat.value)
          }"
            (click)="toggleCategoryFromString(cat.value)"
          ></p-chip>
        }
      </div>
    </div>
  </div>
</p-fieldset>
